import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { PantallasCustomizablesService, IPantallaCustomizableSaveRequest } from './services/pantallas-customizables.service';
import { IPantallaCustomizable, IPantallaCustomizableRequest, IPantallaCustomizableResponse } from './interfaces/pantalla-customizable.interface';
import { SessionService } from '@shared/helpers/sesion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pantallas-customizables',
  templateUrl: './pantallas-customizables.component.html',
  providers: [MessageService]
})
export class PantallasCustomizablesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedPantalla: IPantallaCustomizable | null = null;
  dataSource: IPantallaCustomizable[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'clave', header: 'Código', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'tipo', header: 'Tipo', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private pantallasCustomizablesService: PantallasCustomizablesService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: IPantallaCustomizableRequest = {
      sUsuario: this.sessionService.getUserSession(),
      iNumReg: 9999
    };

    this.pantallasCustomizablesService.getPantallasCustomizables(request).subscribe({
      next: (response: IPantallaCustomizableResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las pantallas customizables'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las pantallas customizables'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedPantalla = null;
    this.displayDialog = true;
  }

  openUpdate(row: IPantallaCustomizable): void {
    this.selectedPantalla = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: IPantallaCustomizable): void {
    // Confirmar antes de eliminar usando SweetAlert2
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro que desea eliminar la pantalla "${row.descripcion}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        const request: IPantallaCustomizableSaveRequest = {
          sUsuario: this.sessionService.getUserSession(),
          iAccion: 3, // Eliminar
          sClave: row.clave,
          sDescrip: row.descripcion,
          sTipoPant: row.tipo,
          iNumReg: 0
        };

        this.pantallasCustomizablesService.savePantallaCustomizable(request).subscribe({
          next: (response) => {
            const errorCode = response.data?.[0]?.error;
            if (errorCode === "0") {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Pantalla customizable eliminada correctamente'
              });
              
              // Recargar los datos después de eliminar
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: errorCode || 'Error al eliminar la pantalla customizable'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la pantalla customizable'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedPantalla = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 